export default "__VITE_ASSET__C9tk80h8__"